import { useQuery } from '@tanstack/react-query';
import { CATEGORY } from '../../../../../../constants/queryKeys';
import categoryApiV2 from '../../../../../../lib/api/category/CategoryApiV2';
import { CATEGORY_DEGREE } from '../../../../../../types/category/common';
import { CATEGORY_STATUS_TYPE } from '../../../../../../constants/service/app/categoryConstants';

export const useMainCategoryList = () => {
  const { data } = useQuery(
    CATEGORY.LIST,
    () =>
      categoryApiV2.getCategoryList({
        degree: CATEGORY_DEGREE.MAIN,
        status: CATEGORY_STATUS_TYPE.ACTIVE,
        pageSize: 100,
        sort: 'id',
      }),
    {
      select: (res) => res.categories.map((category) => ({ id: category.id, name: category.name })),
    },
  );

  return data || [];
};
